import {$_TYPE, $_WC, $_DKD, $_GCD, $_CD, $_ADM, $_DEPT, $_NM} from "@/confs/common.const";

export default {
    install(Vue) {
        const viewScale = Math.ceil(window.innerWidth / 1920);
        Vue.prototype.$_TYPE = $_TYPE;

        // 기본 설정 상수
        Vue.prototype.$_WC = $_WC;

        // 자료 종류 번호
        Vue.prototype.$_DKD = $_DKD;

        // 코드 그룹 상수 정의
        Vue.prototype.$_GCD = $_GCD;

        // 코드 상수 정의
        Vue.prototype.$_CD = $_CD;

        Vue.prototype.$_ADM = $_ADM;

        // 부서 코드
        Vue.prototype.$_DEPT = $_DEPT;

        // 네이버 지도 관련 상수
        Vue.prototype.$_NM = $_NM;
    }
}
